import React from 'react'
import MaintenancePage from '../../Pages/maintainnance/MaintenancePage'

const Service = () => {
  return (
    <>
    <MaintenancePage />
    </>
  )
}

export default Service